define([
	"dojo/_base/declare",
	"csi/types",
	"../SizeChart",
	"./_Number"
], function(declare,types,SizeChart,_Number) {

	return declare(_Number, {
		fromHtmlDynamic: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/editNode) {
			// summary: if no data entered, then store default
			return (this.getEditorValue(ctx, editNode) === "") ? this.DEFAULT : this.inherited(arguments);
		},

		toValueDynamic: function(/*Context*/ctx, /*Heading*/h, /*Number?*/v) {
			// summary: Display blank if the field wasn't initialized
			var	value = this.inherited(arguments);
			return SizeChart.isNotInitialized(value) ? "" : value;
		},

		_getDiff: function(/*Number*/value, /*Number*/target) {
			// summary: return difference between value and target
			return value - target;
		},

		_getFormat: function(/*Context*/ctx, /*Heading*/h) {
			// summary: use custom view option if present, otherwise use configuration setting for format
			if (this._isFraction(ctx)) {
				return types.FORMAT_IN_FRACTION;
			}

			var	fmt = ctx.view.sizeChartDimensionFormat;
			if (fmt == "DEFAULT") {
				fmt = SizeChart.formatAbs;
			}

			return fmt || this.inherited(arguments);
		},

		_isOutOfTolerance: function(/*Context*/ctx, /*Number?*/value, /*Number?*/baseValue) {
			// summary: return true if the value is out of tolerance
			if (value == this.DEFAULT)
				return false;

			if (baseValue == this.DEFAULT)
				return true;

			var	diff = this._getDiff(value, baseValue);
			if (!diff)
				return false;

			var	dim = SizeChart.getSizeChartDimension(ctx);
			var	tol = SizeChart.isNotInitialized(dim.Tolerance) ? 0 : dim.Tolerance;

			if (SizeChart.bPct) {
				tol *= baseValue;
			} else if (diff < 0) {
				tol = SizeChart.isNotInitialized(dim.ToleranceNegative) ? 0 : -dim.ToleranceNegative;
			}

			return !this._equal(diff, 0, tol);
		},

		/**
		 * @override
		 */
		getReactPlaceholderOptions: function(controller, ctx, h) {
			const {oldValue} = controller;
			const value = this.toValueDynamic(ctx, h, oldValue == this.DEFAULT ? null : oldValue);
			return {
				value,
			};
		}
	});
});